<template>
  <div class="modal-content">
    <div class="modal-box modal-save columns is-multiline">
        <div class="column is-12 modal-save-column flex-center">

          <!-- spinner -->
          <div v-if="showFeedback" :class="{'fade-in': showFeedback}" class="column is-12 sdg-graphic-container">
            <div class="flex-center">
              <icon class="save-spinner-svg flex sdg-spinner" name="sdg-wheel"></icon>
            </div>
          </div>

          <!-- laoding done -->
          <div v-else class="columns is-multiline">
            <div class="column is-12 sg-graphic-container flex-center">
              <div class="rotate-in-center">
                <div class="saved-checkmark-circle flex-center">
                  <icon class="large-svg flex fill-green" name="checkmark"></icon>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="column is-12 flex-center">
          <div class="columns is-multiline">
            <div v-if="showFeedback" class="column is-12 flex-center fade-in">
              <span class="spinner-feedback-text">
                {{$t('modal-pdf.spinnerFeedbackText')}}
              </span>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'create-pdf-modal',
  data () {
    return {
      showFeedback: false
    }
  },
  mounted () {
    this.showFeedback = true
  }
}
</script>
